import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import SupportFaqData from "./supportFaqData";
import Typography from "@mui/material/Typography";
import { useMaterialUIController } from "context";
import { useTranslation } from "react-i18next";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    // borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const Support = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = React.useState("");
  const [controller] = useMaterialUIController();
  const { profile } = controller;
  const email = profile.email;
  const faqData = SupportFaqData();
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title={t("pageTitles.support")} />

      <MDBox
        style={{
          background: "#fff",
          padding: "24px",
          marginBottom: "25px",
          borderRadius: "24px",
          boxShadow:
            "0rem 0.25rem 0.375rem -0.0625rem rgb(0 0 0 / 10%), 0rem 0.125rem 0.25rem -0.0625rem rgb(0 0 0 / 6%)",
        }}
      >
        <MDTypography marginBottom={2}>{t("support.title")}</MDTypography>
        <MDTypography fontSize={17} marginBottom={2}>
          {t("support.question")}
        </MDTypography>
        <MDTypography fontSize={17} marginBottom={2}>
          <a
            style={{ color: "#10b0d5" }}
            href={`mailto:support@maxu.co?subject=${t("support.subject", { email })}&body=${t(
              "support.body"
            )}`}
          >
            {t("support.linkText")}
          </a>{" "}
          {t("support.emailText")}
        </MDTypography>
        <MDTypography fontSize={17} marginBottom={2}>
          {" "}
          {t("support.instructions")}
        </MDTypography>
        <MDTypography fontSize={17} marginBottom={2}>
          {" "}
          {t("support.thanks")}
        </MDTypography>
        <MDTypography style={{ fontSize: "18px", textAlign: "right" }}>
          {t("support.signature")}
        </MDTypography>
      </MDBox>

      <MDBox sx={{ padding: "24px 30px", backgroundColor: "#fff", borderRadius: "14px" }}>
        <MDBox>
          {faqData.map((item, index) => {
            return (
              <Accordion
                sx={{ marginBottom: "8px" }}
                expanded={expanded === `panel${index}`}
                onChange={handleChange(`panel${index}`)}
              >
                <AccordionSummary
                  style={{ height: "65px" }}
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <MDTypography sx={{ fontSize: "16px", color: "#344767" }}>
                    {item.question}
                  </MDTypography>
                </AccordionSummary>
                <AccordionDetails>
                  <MDBox paddingLeft={3}>
                    <Typography variant="h5" textAlign="center">
                      {t("instructionToAddChild.title")}
                    </Typography>
                    <Typography fontSize={16}>
                      <strong>{t("instructionToAddChild.step1.0").split(":")[0]}:</strong>
                    </Typography>
                    <ul style={{ listStyleType: "disc", paddingLeft: "30px" }}>
                      <li>
                        <Typography fontSize={16}>
                          {` ${t("instructionToAddChild.step1.0").split(":")[1]}`}
                        </Typography>
                      </li>
                      <li>
                        <Typography fontSize={16}>{t("instructionToAddChild.step1.1")}</Typography>
                      </li>
                    </ul>
                    <Typography fontSize={16}>
                      <strong>{t("instructionToAddChild.step2.0").split(":")[0]}:</strong>
                    </Typography>
                    <ul style={{ listStyleType: "disc", paddingLeft: "30px" }}>
                      <li>
                        <Typography fontSize={16}>
                          {` ${t("instructionToAddChild.step2.0").split(":")[1]}`}
                        </Typography>
                      </li>
                      <li>
                        <Typography fontSize={16}>{t("instructionToAddChild.step2.1")}</Typography>
                      </li>
                      <li>
                        <Typography fontSize={16}>{t("instructionToAddChild.step2.2")}</Typography>
                      </li>
                      <li>
                        <Typography fontSize={16}>{t("instructionToAddChild.step2.3")}</Typography>
                      </li>

                      <li>
                        <Typography fontSize={16}>{t("instructionToAddChild.step2.4")}</Typography>
                      </li>
                      <li>
                        <Typography fontSize={16}>{t("instructionToAddChild.step2.5")}</Typography>
                      </li>
                    </ul>
                    <Typography
                      variant="body2"
                      fontSize={14}
                      color="text.secondary"
                      sx={{ whiteSpace: "normal", lineHeight: 1.6 }}
                      mt={2}
                      dangerouslySetInnerHTML={{
                        __html: t("instructionToAddChild.note"),
                      }}
                    ></Typography>
                  </MDBox>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
};

export default Support;
